import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=24ebbd14&scoped=true&"
import script from "./payResult.vue?vue&type=script&lang=js&"
export * from "./payResult.vue?vue&type=script&lang=js&"
import style0 from "./payResult.vue?vue&type=style&index=0&id=24ebbd14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebbd14",
  null
  
)

export default component.exports